<template>
  <div>
    <template v-for="(btn, key) in actionButtons">
      <base-button
        v-if="canAddShapes && (btn.name === null || drawingModes.includes(btn.name))"
        :key="key"
        :class="{ 'btn-block': btnBlock }"
        :outline="isActive(btn.name)"
        :type="btn.type"
        :size="btnSize"
        :title="btn.title"
        @click="$emit('mode', btn.name)"
      >
        <i class="fas" :class="btn.icon"></i>
      </base-button>
    </template>

    <base-button
      v-if="showFinish"
      :disabled="disableFinish"
      :outline="outline"
      :class="{ 'btn-block': btnBlock }"
      type="success"
      :size="btnSize"
      title="Finalizar Polígono"
      @click="$emit('finish')"
    >
      <i class="fas fa-check"></i>
    </base-button>

    <base-button
      v-if="showUndoPoint"
      :outline="outline"
      :class="{ 'btn-block': btnBlock }"
      type="info"
      :size="btnSize"
      title="Deshacer último punto"
      @click="$emit('undoPoint')"
    >
      <i class="fas fa-undo-alt"></i>
    </base-button>

    <base-button
      v-if="showCancel"
      :outline="outline"
      :class="{ 'btn-block': btnBlock }"
      type="danger"
      :size="btnSize"
      title="Cancelar perímetro"
      @click="$emit('cancel')"
    >
      <i class="fas fa-times"></i>
    </base-button>

    <base-button
      v-if="showUndo"
      :outline="outline"
      :class="{ 'btn-block': btnBlock }"
      type="info"
      :size="btnSize"
      title="Deshacer"
      @click="$emit('undo')"
    >
      <i class="fas fa-undo"></i>
    </base-button>
    <base-button
      v-if="showDelete"
      :disabled="disableDelete"
      :outline="outline"
      :class="{ 'btn-block': btnBlock }"
      type="warning"
      :size="btnSize"
      title="Borrar selección"
      @click="$emit('deleteSelected')"
    >
      <i class="fas fa-eraser"></i>
    </base-button>
    <base-button
      :outline="outline"
      :class="{ 'btn-block': btnBlock }"
      type="danger"
      :size="btnSize"
      title="Borrar todo"
      @click="$emit('deleteAll')"
    >
      <i class="fas fa-trash"></i>
    </base-button>
  </div>
</template>

<script>
export default {
  props: {
    canAddShapes: {
      type: Boolean,
      default: true,
    },

    drawMode: {
      type: String,
      default: null,
    },

    drawingModes: {
      type: Array,
      default: () => [],
    },

    showDelete: {
      type: Boolean,
      default: false,
    },

    disableDelete: {
      type: Boolean,
      default: false,
    },

    showUndo: {
      type: Boolean,
      default: false,
    },

    showFinish: {
      type: Boolean,
      default: false,
    },

    showUndoPoint: {
      type: Boolean,
      default: false,
    },

    showCancel: {
      type: Boolean,
      default: false,
    },

    disableFinish: {
      type: Boolean,
      default: false,
    },

    btnBlock: {
      type: Boolean,
      default: false,
    },

    outline: {
      type: Boolean,
      default: false,
    },

    btnSize: {
      type: String,
      default: 'sm',
    },
  },

  data() {
    return {
      actionButtons: [
        { name: null, type: 'default', icon: 'fa-arrows-alt', title: 'Mover' },
        { name: 'marker', type: 'success', icon: 'fa-map-marker', title: 'Añadir Marcador' },
        { name: 'polygon', type: 'success', icon: 'fa-draw-polygon', title: 'Dibujar Polígono' },
        { name: 'rectangle', type: 'success', icon: 'fa-vector-square', title: 'Dibujar Rectangulo' },
        { name: 'circle', type: 'success', icon: 'fa-drafting-compass', title: 'Dibujar Círculo' },
        { name: 'polyline', type: 'success', icon: 'fa-ruler', title: 'Trazar Línea' },
      ],
    };
  },

  methods: {
    isActive(mode) {
      return (this.outline && this.drawMode !== mode) || (!this.outline && this.drawMode === mode);
    },
  },
};
</script>

<style lang="scss" scoped>
button:disabled {
  opacity: 0.3 !important;
  cursor: not-allowed;
}

.fa:before,
.fas:before {
  font-size: 18px !important;
}
</style>
